import { MutationCache, QueryClient } from '@tanstack/react-query'
import { globalShowToast } from './globalToast'
import { extractErrorMessage } from './utils'

export const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      // Skip if the mutation opts out (component handles errors itself)
      if (mutation.meta?.skipGlobalErrorHandler) return
      globalShowToast('error', extractErrorMessage(error))
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 1 minute
      gcTime: 1000 * 60 * 5, // 5 minutes (was cacheTime in v4)
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})
